import { METERS_PER_MILE } from '@/config/constants';
import { readCoordinatePair } from '@/utils/mapCoordinates';

export const ROUTE_WAIT_MS = 30000;

export const routeMetric = value => {
  if (typeof value !== 'number' || !Number.isFinite(value) || value < 0) {
    throw new Error('Invalid route metric');
  }
  return value;
};

// Both callers retain their own request lifetime. This boundary only translates
// the provider contract; it never retries, mutates runs or reorders stops.
export function googleRouteRequest(origin, coordinates, directions = false) {
  if (typeof origin === 'string') {
    origin = origin.trim();
    if (!origin) throw new Error('Missing shop route origin');
  } else {
    const point = typeof origin?.lat === 'number' && typeof origin?.lng === 'number'
      ? readCoordinatePair(origin.lat, origin.lng) : null;
    if (!point) throw new Error('Invalid shop route origin');
    origin = { lat: point.latitude, lng: point.longitude };
  }
  if (!Array.isArray(coordinates) || !coordinates.length || coordinates.length > 26) {
    throw new Error('Unsupported route stop count');
  }
  const points = Array.from(coordinates, coordinate => {
    const point = readCoordinatePair(coordinate?.latitude, coordinate?.longitude);
    if (!point) throw new Error('Invalid route coordinate');
    return { lat: point.latitude, lng: point.longitude };
  });
  return {
    origin, destination: points[points.length - 1],
    intermediates: points.slice(0, -1).map(location => ({ location })),
    travelMode: 'DRIVING', routingPreference: 'TRAFFIC_UNAWARE',
    optimizeWaypointOrder: false, computeAlternativeRoutes: false,
    fields: directions ? ['path', 'legs', 'warnings'] : ['legs'],
  };
}

export function readGoogleRoute(response, count) {
  const route = response?.routes?.[0];
  if (!Array.isArray(route?.legs) || route.legs.length !== count) throw new Error('Invalid route legs');
  let distance = 0; let duration = 0;
  route.legs.forEach(leg => {
    distance += routeMetric(leg?.distanceMeters);
    duration += routeMetric(leg?.durationMillis);
  });
  routeMetric(distance); routeMetric(duration);
  return { route, routeInfo: {
    distance: (distance / METERS_PER_MILE).toFixed(1), duration: Math.round(duration / 60000),
  } };
}
